import { ReactSetState } from '@models';
import { GenericChangeEvent } from './ChangeEvent';

export type ChangeEventHook<T> = (update: ReactSetState<T>) => void;

export const useChangeHook = <T extends any>(set: ChangeEventHook<T>) => 
(event: GenericChangeEvent) => set(event.value);

export default useChangeHook;
